module.exports = __webpack_public_path__ + "static/img/cdb2.c000cc21.png";